export enum SHIPPING_HISTORY_COLS {
  items = 'items',
  status = 'status',
  deliveredAt = 'deliveredAt',
  trackingUrl = 'trackingUrl',
}
